import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import { useUser } from "../config/userProvider";
import axios from "axios";
import { apiurl } from "../config/config";
import { InfiLoader } from "../components/loader";

const Leaderboard = () => {
  const [leaderBoardData, setLeaderBoardData] = useState([]);
  let { userData } = useUser();
  let vendorObjId = userData?.vendorDetails?.vendorObjId;
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   setLoading(true);
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/analytic/report/leaderboard`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify("Leaderboard", response.data));
  //       if (response.data.success === true) {
  //         setLeaderBoardData(response.data.data);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.log(error);
  //     });
  // }, []);

  // const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!vendorObjId) return;

    setLoading(true);

    let data = JSON.stringify({
      vendorObjId: vendorObjId,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/analytic/report/leaderboard`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Leaderboard", response.data);
        if (response.data.success === true) {
          setLeaderBoardData(response.data.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, [vendorObjId]);

  const filterHandler = (filter) => {
    // console.log("filter", filter);
    if (filter) {
      setLoading(true);
      let data = JSON.stringify({
        vendorObjId: vendorObjId,
        actionType: filter,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/analytic/report/leaderboard/action`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.data.success === true) {
            setLeaderBoardData(response.data.data);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);

          console.log(error);
        });
    }
  };
  // const UpdateLe
  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        {loading === true ? (
          <InfiLoader maintext="Fetching Leaderboard Data..." />
        ) : (
          <div className=" overflow-auto  p-6 min-h-screen capitalize ">
            <div className="max-w-7xl mx-auto">
              {/* Current Leaders Section */}
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-lg md:text-xl lg:text-2xl font-semibold">
                    Current Leaders
                  </h2>

                  <div className="flex gap-4 text-xs md:text-sm lg:text-base">
                    <select
                      onChange={(e) => filterHandler(e.target.value)}
                      className="bg-white border border-gray-300 text-gray-700 py-2 px-2 md:px-4 rounded shadow-sm focus:outline-none capitalize"
                    >
                      <option value="">filters</option>
                      <option value="order_placed">Orders</option>
                      <option value="catalog_generated"> Generated</option>
                      <option value="catalog_downloaded">downloaded</option>
                      <option value="catalog_sent_email"> mail</option>
                      <option value="catalog_sent_whatsapp">whatsapp</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {/* Leader Cards */}
                  {leaderBoardData[0] && (
                    <WinnerCard
                      // key={index}
                      name={leaderBoardData[0]?.userName}
                      orders={leaderBoardData[0]?.totalActions}
                      url="/medal1.png"
                      Generated={
                        leaderBoardData[0]?.breakdown?.catalog_generated
                      }
                      mail={leaderBoardData[0]?.breakdown?.catalog_sent_email}
                      whatsapp={
                        leaderBoardData[0]?.breakdown?.catalog_sent_whatsapp
                      }
                    />
                  )}
                  {leaderBoardData[1] && (
                    <WinnerCard
                      // key={index}
                      name={leaderBoardData[1]?.userName}
                      orders={leaderBoardData[1]?.totalActions}
                      url="/medal2.png"
                      Generated={
                        leaderBoardData[1]?.breakdown?.catalog_generated
                      }
                      mail={leaderBoardData[1]?.breakdown?.catalog_sent_email}
                      whatsapp={
                        leaderBoardData[1]?.breakdown?.catalog_sent_whatsapp
                      }
                    />
                  )}
                  {leaderBoardData[2] && (
                    <WinnerCard
                      // key={index}
                      name={leaderBoardData[2]?.userName}
                      orders={leaderBoardData[2]?.breakdown?.order_placed}
                      url="/medal3.png"
                      Generated={
                        leaderBoardData[2]?.breakdown?.catalog_generated
                      }
                      mail={leaderBoardData[2]?.breakdown?.catalog_sent_email}
                      whatsapp={
                        leaderBoardData[2]?.breakdown?.catalog_sent_whatsapp
                      }
                    />
                  )}
                </div>
              </div>

              {/* Global Ranking Section */}
              <div className="mt-8">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-lg md:text-xl lg:text-2xl font-semibold">
                    {" "}
                    Ranking
                  </h2>
                </div>
                <table className="w-full bg-white rounded-lg shadow">
                  <thead>
                    <tr className="bg-gray-100  capitalize">
                      {[
                        "Rank",
                        "User name",
                        "Generated",
                        "mailed",
                        "whatsapp",
                        "downloads",
                        "Order Placed",
                      ].map((header, index) => (
                        <th
                          key={index}
                          className={`${
                            index === 0 || index === 1
                              ? "text-left"
                              : "text-center"
                          } text-left py-3 px-4 text-gray-600 text-xs md:text-sm font-medium`}
                        >
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {leaderBoardData.map((user, index) => (
                      <tr
                        key={index}
                        className="border-b last:border-b-0 hover:bg-gray-50"
                      >
                        <td className="py-3 px-4">{index + 1}</td>
                        <td className="py-3 px-4">
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8  bg-zinc-100 rounded-full text-slate-600 flex justify-center items-center font-bold md:text-sm text-xs ">
                              {user?.userName?.[0] || ""}
                            </div>
                            <div>
                              <p className="font-medium md:text-base text-sm">
                                {user?.userName}
                              </p>
                              <p className="md:text-sm text-xs text-gray-500">
                                {user?.userId}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-center">
                          {user?.breakdown?.catalog_generated}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {user?.breakdown?.catalog_sent_email}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {user?.breakdown?.catalog_sent_whatsapp}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {user?.breakdown?.catalog_downloaded}
                        </td>
                        <td className="py-3 px-4 text-center">
                          {user?.breakdown?.order_placed}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default Leaderboard;

const WinnerCard = ({ icon, name, orders, url, Generated, mail, whatsapp }) => {
  return (
    <div className="bg-white rounded-lg shadow border flex flex-col">
      <div className="flex justify-between items-center p-5">
        <div className="flex items-center gap-2">
          <div className="w-8 md:w-16 h-8 md:h-16 bg-zinc-100 rounded-full flex items-center justify-center">
            <span className="text-xl font-semibold text-slate-600">
              {name?.[0] || ""}
            </span>
          </div>
          <div>
            <h3 className="font-medium text-xs md:text-base text-slate-500">
              {name}
            </h3>
            <p className="md:text-xl text-sm font-bold">{orders}</p>
          </div>
        </div>
        {url && <img src={url} alt="Leader Icon" className="md:h-10 h-6" />}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 mt-4 text-center border-t">
        <div className="p-3">
          <p className="text-sm text-gray-500">Generated</p>
          <p className="font-medium">{Generated}</p>
        </div>
        <div className="border-x p-3">
          <p className="text-sm text-gray-500">mail</p>
          <p className="font-medium">{mail}</p>
        </div>
        <div className="p-3 border-t md:border-none col-span-2 md:col-span-1">
          <p className="text-sm text-gray-500">whatsapp</p>
          <p className="font-medium">{whatsapp}</p>
        </div>
      </div>
    </div>
  );
};
